import { Button, Field, makeStyles, Text } from "@fluentui/react-components";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

interface IFileFieldProps {
    file?: File;
    labelKey: string;
    isDisabled: boolean;
    onFileChange: (files?: FileList) => void;
}

const useStyles = makeStyles({
    formCol: {
        flex: 1
    },
    btnUpload: {
        width: "100%"
    },
    filename: {
        marginTop: "4px",
        display: "block",
        wordBreak: "break-all"
    },
});

export default function FileField(props: IFileFieldProps) {
    const { t } = useTranslation("recruitment");
    const styles = useStyles();
    const ref = useRef<HTMLInputElement>(null);

    const handleFileChange = (target: HTMLInputElement) => {
        const files = target.files;
        props.onFileChange(files!);
    }

    return (
        <Field label={t(props.labelKey)} className={styles.formCol} required>
            <input
                ref={ref}
                type="file"
                accept=".pdf,.docx,.doc,.rtf"
                disabled={props.isDisabled}
                onChange={e => handleFileChange(e.target)}
                />
            <Button
                appearance="secondary"
                type="button"
                onClick={() => ref.current?.click()}
                className={styles.btnUpload}
                disabled={props.isDisabled}
                >
                {
                    props.file
                        ? t("register.form.changeFile")
                        : t("register.form.uploadFile")
                }
            </Button>
            
            {
                props.file &&
                <Text size={200} className={styles.filename}>
                    {props.file.name}
                </Text>
            }
        </Field>
    );
}